import Title from 'antd/es/typography/Title'
import { FC } from 'react'
import PageLayout from '../components/page-layout/page-layout'
import { useUser } from '../hooks/use-user'

interface HomePageProps {}

const HomePage: FC<HomePageProps> = () => {
    const user = useUser()
    return (
        <PageLayout title={'Дашборд'}>
            <Title level={2}> Здравствуйте, {user?.username.split(' ')[1]}!</Title>
        </PageLayout>
    )
}

export default HomePage
